<template>
  <PageWrapper hasFilters @submitFilters="setFilters">
    <template #title> گزارش فعالیت کاربر ها </template>
    <template #filters>
      <ReportTypePicker
        class="w-24 filters-width"
        v-model="reportType"
      ></ReportTypePicker>
    </template>
    <GeneralLineChart ref="chart" :getChartData="getUserActivitiesReport">
    </GeneralLineChart>
  </PageWrapper>
</template>
<script>
export default {
  data() {
    return {
      reportType: 1,
    };
  },
  methods: {
    setFilters() {
      this.$refs?.chart?.sendChartRequest();
    },
    async getUserActivitiesReport(_this) {
      try {
        _this.isRenderingChart = false;
        let oneMonthAgo = new Date(
          new Date().setMonth(new Date().getMonth() - 1)
        ).toISOString();
        let userActivitiesReportByDateTime = new UserActivitiesReportByDateTime(
          _this
        );
        userActivitiesReportByDateTime.setRequestParamDataObj({
          startDate: oneMonthAgo,
          reportType: this.reportType,
        });
        await userActivitiesReportByDateTime.fetch((res) => {
          _this.chartOptions.series = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (
            res &&
            res.data &&
            res.data.report &&
            res.data.report.length > 0
          ) {
            res.data.report.forEach((item) => {
              myLabelArray.push(
                `${this.customFullDateConvert(
                  item.startOfInterval
                )} - ${this.customFullDateConvert(
                  new Date(
                    new Date(item.startOfInterval).setDate(
                      new Date(item.startOfInterval).getDate() - 7
                    )
                  )
                )}`
              );
              myDataArray.push(item.totalCount);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });
            _this.chartOptions["tooltip"]["y"]["title"]["formatter"] = (
              seriesName
            ) => " کاربران فعال: ";
            _this.chartOptions["xaxis"]["title"]["text"] = "بازه‌ی هفته";
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    GeneralLineChart,
    ReportTypePicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import GeneralLineChart from "@/views/dashboard/analytics/UserReport/GeneralLineChart.vue";
import ReportTypePicker from "@/views/components/Reports/ReportTypePicker.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { UserActivitiesReportByDateTime } from "@/libs/Api/Users";
</script>
